// frontend/src/components/Login.js
import React, { useState } from 'react';
import './Auth.css';

function Login({ onLoginSuccess, switchToRegister }) {
  const [mailAddress, setMailAddress] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleLogin = async () => {
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mailAddress, password }),
      });

      const data = await res.json();

      if (res.ok) {
        localStorage.setItem('token', data.accessToken);
        setMessage('ログイン成功');
        onLoginSuccess();
      } else {
        setMessage(data.error || 'ログインに失敗しました');
      }
    } catch (error) {
      setMessage('通信エラー');
      console.error(error);
    }
  };

  return (
    <div className="auth-container">
      <h2>MOZ DB ログイン</h2>
      <input
        type="email"
        placeholder="メールアドレス"
        value={mailAddress}
        onChange={(e) => setMailAddress(e.target.value)}
      />
      <input
        type="password"
        placeholder="パスワード"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button onClick={handleLogin}>ログイン</button>
      {message && <p className="auth-message">{message}</p>}


    </div>
  );
}

export default Login;
